<template>
  <div id="travelog" class="section-wrapper">
    <SectionTitle :title="title" />
    <div class="section-content">
      <div
        v-scroll-reveal.reset="vScrollOpts.right"
        ref="maps"
        id="maps"
        class="maps section-grid-item"
      >
        <google-map-marker v-bind:places="places"></google-map-marker>
      </div>
      <Gallery :filteredImages="images" />
    </div>
  </div>
</template>

<script>
  import geoJson from '../content/images/geoJson.json'
  import Gallery from './Gallery'
  import GoogleMapMarker from './MapMarker.vue'
  import { mapActions, mapState } from 'vuex'
  import SectionTitle from '../commonComponents/SectionTitle'
  export default {
    name: 'Travelog',
    components: {
      Gallery,
      GoogleMapMarker,
      SectionTitle
    },
    provide: function() {
      return {
        getMap: this.getMap
      }
    },

    data() {
      return {
        map: null,
        places: [],
        gallery: { right: false, bottom: true },
        title: 'Travelog'
      }
    },

    methods: {
      ...mapActions(['getGalleryImages']),
      getMap(found) {
        var vm = this
        function checkForMap() {
          if (vm.map) {
            found(vm.map)
          } else {
            setTimeout(checkForMap, 50)
          }
        }
        checkForMap()
      }
    },
    computed: {
      ...mapState(['currentMarkers', 'galleryImages', 'vScrollOpts']),

      images() {
        const mapNames = this.currentMarkers.map(item => {
          return item.title
        })

        return this.galleryImages.filter(image => {
          const imageName = image.split('/').pop()
          return mapNames.includes(imageName)
        })
      }
    },

    mounted() {
      import('./../helpers/gmaps').then(async gmapsInit => {
        const galleryImages = [],
          places = []

        for (const img of geoJson.features) {
          galleryImages.push(img.properties.name)
        }
        this.getGalleryImages({ galleryImages })

        try {
          const google = await gmapsInit.default(),
            map = new google.maps.Map(this.$refs.maps, {
              zoom: 2,
              center: { lat: 158.673983, lng: 46.6559 }
            })

          google.maps.event.addListener(map.data, 'addfeature', e => {
            if (e.feature.getGeometry().getType() === 'Point') {
              places.push({
                position: e.feature.getGeometry().get(),
                title: e.feature.getProperty('name')
              })
              map.setCenter(e.feature.getGeometry().get())
            }
          })

          this.places = places
          map.data.addGeoJson(geoJson)
          map.data.setMap(null)
          this.map = map
        } catch (error) {
          console.error(error)
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  @include section {
    .section-wrapper {
      min-height: 100vh;
      .section-content {
        height: 85vh;
        position: relative;
        flex-wrap: nowrap;
        @include sectionGridItem {
          .section-grid-item.maps {
            overflow: hidden;
            flex: 0.85 85%;
            min-height: 20rem;
            height: 100%;
            margin-bottom: 1rem;
            padding: 0;
          }
        }
      }

      @include small-breakpoint {
        .section-content {
          .section-grid-item.maps {
            flex: 0.65 65%;
          }
        }
      }

      @include large-breakpoint {
        .section-content {
          .section-grid-item.maps {
            flex: 0.55 55%;
          }
        }
      }
    }
  }
</style>
